module.exports = __webpack_public_path__ + "img/Fundamental analysis.c95de781.svg";